export const getSalutationTypes = () => {
  return [
    { name: 'Mr.', value: 'Mr.' },
    { name: 'Ms.', value: 'Ms.' }
  ]
}

export const getTaxStatusTypes = () => {
  return [
    { name: 'FTX (Taxable 20%)', value: 'FTX' },
    { name: 'NWT (Tax-Exempt 0%)', value: 'NWT' },
    { name: 'FMX (Taxable 25%)', value: 'FMX' },
    { name: 'FMXN (Taxable 30%)', value: 'FMXN' }
  ]
}

export const getGraduatedTaxStatusTypes = () => {
  return [
    { name: 'FT20 (20%)', value: 'FT20' },
    { name: 'FT12 (12%)', value: 'FT12' },
    { name: 'FT05 (5%)', value: 'FT05' }
  ]
}

export const getNonStockProfitTypes = () => {
  return [
    { name: 'Yes', value: 'Yes' },
    { name: 'No', value: 'No' }
  ]
}

export const getToTypes = () => {
  return [
    { name: 'Broker', value: 'Broker' },
    { name: 'Custodian', value: 'Custodian' },
    { name: 'Dealer', value: 'Dealer' }
  ]
}
